'use strict';
import React from 'react';
import LicensingListingItem from './licensingListingItem';
import flux from 'utils/flux';

var LicensingListing = React.createClass({
    displayName: 'LicensingListing',
    mixins: [],
    propTypes: {},
    render() {

        // SHow success page??
        if (this.props.query.success && this.props.query.success === 'true') {
            return (
                <div className="licensing__success">
                    <h2>{flux.t('licensing_success')}</h2>
                    <p>{flux.t('licensing_success_subtext')}</p>
                </div>
            );
        }

        if (this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
            return (
                <div className="licensing__empty">
                    <p>{flux.t('no_basket_selected')}</p>
                </div>);
        }

        return (
            <div className="licensing__listing">
                {this.props.basket.get('items').map((item) => {
                    return <LicensingListingItem key={'llitem-' + item.get('id')} item={item}/>;
                })}
            </div>
        );
    }
});

module.exports = LicensingListing;



// WEBPACK FOOTER //
// ./app/pages/licensing/listing/licensingListing.jsx